/*
 * @author: wayou
 * @date: 2018-12-05 12:00:53
 * @description: 作业小节页面中作业列表获取列表数据
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';
import { IHomeworkInfo } from '@umu/umu-types';

export interface IGetHomeworkListRequest {
    parent_id: string;
    get_others: number;
    is_shield: number;
    page: number;
    size: number;
    sort_type: number;
    reverse: number;
    score_status: number;
    doc_status: string;
}

export interface IGetHomeworkListResponse {
    list: IHomeworkInfo[];
    // 老接口，其pageinfo 与标准的不一样
    pageInfo: {
        totalPage: number;
        currentPage: number;
        pageSize: number;
        totalNum: number;
    };
}

export const getHomeworkListAsync = (params: IGetHomeworkListRequest): Promise<IResponse<IGetHomeworkListResponse>> => {
    return fetchData(Api.GET_HOMEWORK_LIST, params).then((res: IResponse<IGetHomeworkListResponse>) => {
        return res;
    });
};

export const getHomeworkList = fetchDataSync(
    (data: IGetHomeworkListRequest): Promise<IResponse<IGetHomeworkListResponse>> => {
        return fetchData(Api.GET_HOMEWORK_LIST, data).then((res: IResponse<IGetHomeworkListResponse>) => {
            return res;
        });
    },
);
